import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function initStickyBookNow() {
    const calendar = document.querySelector('.section-activity-calendar');
    const bookNowBtn = document.querySelector('.btn-booknow');

    if (!calendar || !bookNowBtn) {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
        trigger: calendar,
        start: 'bottom top',
        end: 'bottom top',
        onEnter: () => {
            bookNowBtn.classList.add('visible');
        },
        onLeaveBack: () => {
            bookNowBtn.classList.remove('visible');
        },
    });
}
